import { touroService } from '../_services/';
import alerts from '../_components/alerts';

export const touroAction = {
    getTouro,
    getTouroById,
    getTouroSelect,
    getTouroByFazendaSelect,
    onChangeProps,
    clear
};
function getTouro(showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'touros';
        touroService.get(apiEndpoint)
            .then((response) => {
                dispatch(changeTourosList(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            })
    };
}
function getTouroById(id, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'touros/' + id;
        touroService.get(apiEndpoint)
            .then((response) => {
                dispatch(editTourosDetails(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            })
    };
}
function getTouroSelect() {
    return dispatch => {
        let apiEndpoint = 'touros/select';
        touroService.get(apiEndpoint)
            .then((response) => {
                dispatch(changeTourosList(response.data));
            }).catch((err) => {
                console.log(err);
            })
    };
}
function getTouroByFazendaSelect(id) {
    return dispatch => {
        let apiEndpoint = 'touros/fazenda/select/' + id;
        touroService.get(apiEndpoint)
            .then((response) => {
                dispatch(changeTourosList(response.data));
            }).catch((err) => {
                console.log(err);
            })
    };
}
function onChangeProps(props, event) {
    return dispatch => {
        dispatch(handleOnChangeProps(props, event.target.value));
    }
}
export function changeTourosList(touro) {
    return {
        type: "FETECHED_ALL_TOURO",
        touro: touro
    }
}
export function clear() {
    return {
        type: "TOURO_CLEAR"
    };
}
export function handleOnChangeProps(props, value) {
    return {
        type: "HANDLE_ON_CHANGE",
        props: props,
        value: value
    }
}
export function editTourosDetails(touro) {
    return {
        type: "TOURO_DETAIL",
        id: touro.id,
        id_fazenda: touro.id_fazenda,
        data: touro.data,
        tipo_relatorio: touro.tipo_relatorio,
        arquivo: touro.arquivo,
        obs: touro.obs,
        data_cadastro: touro.data_cadastro,
        usuario_cadastro: touro.usuario_cadastro,
        data_exclusao: touro.data_exclusao,
        usuario_exclusao: touro.usuario_exclusao,
        fazenda: touro.fazenda
    }
}
export function updatedUserInfo() {
    return {
        type: "TOURO_UPDATED"
    }
}
export function createUserInfo() {
    return {
        type: "TOURO_CREATED_SUCCESSFULLY"
    }
}
export function deleteTourosDetails() {
    return {
        type: "DELETED_TOURO_DETAILS"
    }
}